// SETTINGS V2 atom — SCard. Card with optional eyebrow header + action slot.
// Port of designer settings-kit.jsx SCard (lines 32-46). Inline styles + CSS-var
// tokens only (resolve inside .settings-v2-root); no MUI / sx / dt / Tailwind.
import React from "react";

export interface SCardProps {
  title?: string;
  hint?: string;
  action?: React.ReactNode;
  pad?: string;
  /**
   * Full-bleed body: the card itself carries NO padding (so a table / row list /
   * footnote strip inside can span edge-to-edge with their own insets), but the
   * eyebrow header + hint still get a consistent inset (16px top / 20px sides —
   * the same rhythm as the default-padded Profil/Firma/Lokácie cards) so they are
   * never flush against the card's top/side edges. Replaces the earlier
   * `pad="16px 0 0"` full-bleed hack that left the header cramped in the corner.
   */
  bleed?: boolean;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const SCard: React.FC<SCardProps> = ({
  title,
  hint,
  action,
  pad = "16px 20px",
  bleed = false,
  style,
  children,
}) => (
  <div
    style={{
      background: "var(--card)",
      border: "1px solid var(--border)",
      borderRadius: 12,
      boxShadow: "var(--shadow)",
      padding: bleed ? 0 : pad,
      ...style,
    }}
  >
    {(title || action) && (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: bleed ? "16px 20px 0" : 0,
          marginBottom: hint ? 4 : 14,
        }}
      >
        <span className="eyebrow" style={{ color: "var(--mod-accent)" }}>
          {title}
        </span>
        <span style={{ flex: 1 }} />
        {action}
      </div>
    )}
    {hint && (
      <div
        style={{
          fontSize: 12.5,
          color: "var(--muted)",
          lineHeight: 1.55,
          padding: bleed ? "0 20px" : 0,
          marginBottom: 14,
        }}
      >
        {hint}
      </div>
    )}
    {children}
  </div>
);

export default SCard;
